import {connect} from 'react-redux';
import {Modal as Component} from './Modal';
import {
  setModal,
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

    return {
      display: state.notebook.protocolSection.scene.modal.display,
      type: state.notebook.protocolSection.scene.modal.type,
      size: state.notebook.protocolSection.scene.modal.size,
      connect: state.notebook.protocolSection.scene.modal.connect,
      data: state.notebook.protocolSection.scene.modal.data,

      pipetteId: state.notebook.protocolSection.scene.modal.pipetteId,
      waterBathId: state.notebook.protocolSection.scene.modal.waterBathId,
      gelId: state.notebook.protocolSection.scene.modal.gelId,
      gelBoxId: state.notebook.protocolSection.scene.modal.gelBoxId,
      noteEntryOpen: state.notebook.protocolSection.scene.noteEntryOpen,
      sectionSelected: state.notebook.protocolSection.scene.sectionSelected,
      notebookExpanded: !state.notebook.notebookCollapsed
    }

}

function mapDispatchToProps(dispatch) {
  return {
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const Modal = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
